import React, { useState } from "react";
import {
  MdShoppingBasket,
  MdCalendarMonth,
  MdPayments,
  MdFormatQuote,
  MdChevronLeft,
  MdChevronRight,
  MdPerson,
} from "react-icons/md";
import styles from "./HowItWorks.module.css";

interface Testimonial {
  id: number;
  text: string;
  name: string;
  role: string;
}

export default function HowItWorks() {
  const [startIndex, setStartIndex] = useState(0);

  const steps = [
    {
      icon: <MdShoppingBasket size={36} />,
      title: "Buy a Product or Service",
    },
    {
      icon: <MdCalendarMonth size={36} />,
      title: "Schedule your Date & Time",
    },
    {
      icon: <MdPayments size={36} />,
      title: "Pay Online",
    },
  ];

  const testimonials: Testimonial[] = [
    {
      id: 1,
      name: "Nikhil Mistry",
      role: "Entrepreneur",
      text: "I recently used Mechmiles for my tire replacement, and I am beyond impressed! The convenience of booking through their website and the expert recommendations for my vehicle made the entire process seamless.",
    },
    {
      id: 2,
      name: "Siddharth Sharma",
      role: "Manager",
      text: "Kudos to the Mechmiles team for their exceptional tire service! I appreciated the detailed information on tire options available for my car. The professionalism and efficiency displayed during the replacement were remarkable.",
    },
    {
      id: 3,
      name: "Raju Rathod",
      role: "Engineer",
      text: "I cannot thank Mechmiles enough for their outstanding tire-related services. From tire selection to the installation process, everything was smooth and hassle-free. The team's knowledge and attention to detail instilled confidence.",
    },
    {
      id: 4,
      name: "Vikram Malhotra",
      role: "Fleet Director",
      text: "We transitioned our entire commercial truck fleet's tyre management over to Mechmiles. The turnaround times have dropped by 30%, and the volume discounts have significantly lowered our operating expenses.",
    },
    {
      id: 5,
      name: "Ananya Roy",
      role: "Automotive Blogger",
      text: "Finding genuine performance-rated tyres for superbikes is a challenge in India. Mechmiles solved this perfectly with direct-from-manufacturer supplies and certified installation points.",
    },
  ];

  // Show up to 3 testimonials at once
  const visibleTestimonials = testimonials.slice(startIndex, startIndex + 3);

  // Pad with wrap-around items if we reach the end on small screens/desktop
  const getVisibleTestimonials = () => {
    const list = [];
    for (let i = 0; i < 3; i++) {
      list.push(testimonials[(startIndex + i) % testimonials.length]);
    }
    return list;
  };

  const handleNext = () => {
    setStartIndex((prev) => (prev + 1) % testimonials.length);
  };

  const handlePrev = () => {
    setStartIndex(
      (prev) => (prev - 1 + testimonials.length) % testimonials.length,
    );
  };

  return (
    <section className={styles.howItWorksSection}>
      <div className={styles.container}>
        {/* 3 Steps Board */}
        {/* <div className={styles.stepsBoard}>
          <div className={styles.stepsHeader}>
            <h2 className={styles.stepsTitle}>Quick 3-Steps To Schedule Your Appointment</h2>
            <button className={styles.knowMoreBtn}>Know More</button>
          </div>
          <div className={styles.stepsGrid}>
            {steps.map((step, idx) => (
              <div key={idx} className={styles.stepCard}>
                <div className={styles.stepIconCircle}>
                  {step.icon}
                </div>
                <h3 className={styles.stepTitle}>{step.title}</h3>
                {idx < 2 && <div className={styles.stepConnector} />}
              </div>
            ))}
          </div>
        </div> */}
        <div className={styles.stepsBoard}>
          <div className={styles.bgOverlay}></div>

          <div className={styles.stepsContent}>
            <div className={styles.stepsHeader}>
              <h2 className={styles.stepsTitle}>
                Quick 3-Steps To Schedule Your Appointment
              </h2>
              <button className={styles.knowMoreBtn}>Know More</button>
            </div>

            <div className={styles.stepsGrid}>
              {steps.map((step, idx) => (
                <div key={idx} className={styles.stepCard}>
                  <div className={styles.stepIconCircle}>{step.icon}</div>
                  <h3 className={styles.stepTitle}>{step.title}</h3>
                  {idx < 2 && <div className={styles.stepConnector} />}
                </div>
              ))}
            </div>
          </div>
        </div>
        {/* Testimonials Header */}
        <div className={styles.testimonialsHeader}>
          <h2 className={styles.testimonialSectionTitle}>
            What our clients say about us
          </h2>
          <div className={styles.sliderControls}>
            <button
              onClick={handlePrev}
              className={styles.sliderBtn}
              aria-label="Previous Testimonials"
            >
              <MdChevronLeft size={24} />
            </button>
            <button
              onClick={handleNext}
              className={styles.sliderBtn}
              aria-label="Next Testimonials"
            >
              <MdChevronRight size={24} />
            </button>
          </div>
        </div>

        {/* Testimonials Grid */}
        <div className={styles.testimonialsGrid}>
          {getVisibleTestimonials().map((testimonial, index) => (
            <div
              key={`${testimonial.id}-${index}`}
              className={styles.testimonialCard}
            >
              <span className={styles.quoteIcon}>
                <MdFormatQuote size={40} />
              </span>
              <p className={styles.testimonialText}>{testimonial.text}</p>
              <div className={styles.authorRow}>
                <div className={styles.avatarCircle}>
                  <span className={styles.avatarIcon}>
                    <MdPerson size={24} />
                  </span>
                </div>
                <div className={styles.authorMeta}>
                  <div className={styles.authorName}>{testimonial.name}</div>
                  <div className={styles.authorRole}>{testimonial.role}</div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
